import { LocalizedError } from '@unistocks/types/error/localized-error';

export const isHandledError = (error: unknown): error is LocalizedError => {
  return (error as any)?.error?.code && (error as any)?.error?.message;
};
